export default __webpack_public_path__ + "static/media/rapidsense_long.4ee96bf1.svg";